import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoriaIndexComponent } from './categoria-index/categoria-index.component';
import { CategoriaViewComponent } from './categoria-view/categoria-view.component';
import { CategoriaCreateComponent } from './categoria-create/categoria-create.component';
import { CategoriaUpdateComponent } from './categoria-update/categoria-update.component';
import {Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgSelectModule } from '@ng-select/ng-select';

const routes: Routes = [
  { path: 'index', component: CategoriaIndexComponent },
  { path: '**', redirectTo: 'index' }
];

@NgModule({
  declarations: [
    CategoriaIndexComponent,
    CategoriaViewComponent,
    CategoriaCreateComponent,
    CategoriaUpdateComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgSelectModule
  ]
})
export class CategoriaModule { }
